import { GenericInterpret } from "../../components";

export default GenericInterpret;
